import { render, staticRenderFns } from "./AdminTab.vue?vue&type=template&id=35fc24a6&scoped=true&"
import script from "./AdminTab.vue?vue&type=script&lang=js&"
export * from "./AdminTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc24a6",
  null
  
)

export default component.exports